import {
  PUSH_BREADCRUMB_ITEM,
  POP_BREADCRUMB_ITEM,
  RESET_BREADCRUMB,
} from 'src/redux/Actions/Type';

const LOCAL_STORAGE_KEY = 'breadcrumbItems';

const initialState = () => {
  const stored = localStorage.getItem(LOCAL_STORAGE_KEY);
  return {
    breadcrumbItems: stored ? JSON.parse(stored) : [],
  };
};

const breadcrumbReducer = (state = initialState(), action = {}) => {
  const { type, payload } = action;
  let updatedItems = [...state.breadcrumbItems];

  switch (type) {
    case PUSH_BREADCRUMB_ITEM: {
      updatedItems = updatedItems.filter(
        (item) => item.pathname !== payload.pathname,
      );
      updatedItems.push(payload);
      break;
    }

    case POP_BREADCRUMB_ITEM: {
      if (payload.mode === 'shiftFirst') {
        updatedItems = updatedItems.slice(1);
      } else {
        const index = updatedItems.findIndex(
          (item) => item.pathname === payload.pathname,
        );
        if (index !== -1) {
          updatedItems = updatedItems.slice(0, index + 1);
        }
      }
      break;
    }

    case RESET_BREADCRUMB: {
      if (payload === true) {
        const dashboard = state.breadcrumbItems.find(
          (item) => item.label === 'Dashboard',
        );
        updatedItems = dashboard ? [dashboard] : [];
      } else {
        updatedItems = [];
      }
      break;
    }

    default:
      return state;
  }

  localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(updatedItems));

  return {
    ...state,
    breadcrumbItems: updatedItems,
  };
};

export default breadcrumbReducer;
